module.exports = __webpack_public_path__ + "img/petroleum.6eaffe4e.jpg";